import React, { useEffect, useState } from "react";

import CardOverlap from "./cardoverlap";
import { dataListsType } from "./featured-posts";
import { DataLists } from "../dataLists/DataLists";

const Lifestyle: React.FC = () => {
  const [destinationsData, setDestinationsData] = useState<dataListsType[]>([]);
  const [activitiesData, setActivitiesData] = useState<dataListsType[]>([]);
  const [cuisinesData, setCuisinesData] = useState<dataListsType[]>([]);

  const getDestinationsData = () => {
    const allData = [...DataLists];
    const allGuidesData = allData.filter((item) => item.category === "Guides");
    setDestinationsData(allGuidesData);
  };

  const getActivitiesData = () => {
    const allData = [...DataLists];
    const allTravelData = allData.filter((item) => item.category === "Travel");
    setActivitiesData(allTravelData);
  };

  const getCuisinesData = () => {
    const allData = [...DataLists];
    const allFoodData = allData.filter((item) => item.category === "Food");
    setCuisinesData(allFoodData);
  };

  useEffect(() => {
    getDestinationsData();
    getActivitiesData();
    getCuisinesData();
  }, []);

  return (
    <div className="w-full flex justify-center py-12">
      <div className="w-full max-w-[1116px] px-8 flex flex-col items-center">
        <div className="w-full flex justify-between">
          <div className="w-[32%] flex flex-col">
            <div className="mb-8  border-b-[1px]">
              <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-widest">
                Destinations
              </h5>
              <span className="block w-14 h-[3px] bg-black"></span>
            </div>

            <CardOverlap
              props={destinationsData
                .sort(() => 0.5 - Math.random())
                .slice(0, 3)}
            />
          </div>
          <div className="w-[32%] flex flex-col">
            <div className="mb-8  border-b-[1px]">
              <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-widest">
                Activities
              </h5>
              <span className="block w-14 h-[3px] bg-black"></span>
            </div>
            <CardOverlap
              props={activitiesData.sort(() => 0.5 - Math.random()).slice(0, 3)}
            />
          </div>
          <div className="w-[32%] flex flex-col">
            <div className="mb-8  border-b-[1px]">
              <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-widest">
                Cuisines
              </h5>
              <span className="block w-14 h-[3px] bg-black"></span>
            </div>
            <CardOverlap
              props={cuisinesData.sort(() => 0.5 - Math.random()).slice(0, 3)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lifestyle;
